import React, {useEffect, useState} from "react";
import {useEventContext} from "../../../../context";
import {eventStatisticActivityTopGet} from "../../../../../api/cp";
import Loading from "../../../Loading";
import ActivityTop from "./ActivityTop";
import {Event} from "../../../Comet";

export default () => {
    const {event} = useEventContext();
    const [activityTop, setActivityTop] = useState(null);

    useEffect(() => {
        eventStatisticActivityTopGet(event.eventPassword)
            .then(activityTop => setActivityTop(activityTop))
        ;
    }, []);

    const onUpdate = (result) => {
        // setActivityTop(() => result); // Отключено, так как с комета прилетает ограниченный результат для плеера
    }

    if (null === activityTop) {
        return <Loading/>
    }

    return (
        <>
            <Event event={'activityTop'} handler={(result) => setActivityTop(result)} />
            {/* <Event event={'activityTop'} handler={(result) => onUpdate(result)} /> */}
            <ActivityTop event={event} activityTop={activityTop} />
        </>
    )
}
